<template>
  <v-card>
    <vue-title :title="race.name" />
    <v-card-text class="v-card__text">
        <v-form v-model="valid">
            <v-text-field v-model="race.name" :label="this.$t('races.name')"/>
            <v-select :items="applicationTypes" item-text="name" item-value="id" v-model="race.applicationType" :label="this.$t('application.type')"/>
            <v-text-field v-model="race.startNumberOffset" :label="this.$t('races.startNumberOffset')"/>
            <v-select :items="races" v-model="race.previousRaceId" :label="this.$t('races.previousRace')" item-text="name" item-value="id" />
            <v-text-field v-model="race.maximalRuns" :label="this.$t('races.maximalNumberOfRuns')" />
            <v-checkbox v-model="race.publicDisplay" :label="this.$t('races.publicDisplay')" />
            <v-checkbox v-model="race.announcement" :label="this.$t('races.announcement')" />
        </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save()" color="success">{{$t('ctrl.save')}}</v-btn>
    </v-card-actions>
    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :timeout="5000">
      {{ $t('ctrl.successfullySaved') }}
      <v-btn
        color="red"
        @click="snackbar = false">
        {{ $t('ctrl.close') }}
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
    VSnackbar,
    VCheckbox
  } from 'vuetify/lib'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCCompetitionDetails',
    data: () => ({
      snackbar: false,
      race: {
        name: "",
        applicationType: 0,
        startNumberOffset: 0,
        previousRaceId: null,
        maximalRuns: null,
        publicDisplay: false,
        announcement: false
      },
      races: null,
      valid: false
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      applicationTypes: function () {
        return [this.$t("application.individual"), this.$t("application.tandem"), this.$t("application.relay")]
          .map((e, i)=>{return {id: i, name: e}})
      },
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        VSnackbar,
        VCheckbox
    },
    mounted: function(){
      if(this.$route.params.id != 'new'){
        fccapi.get(`races/${this.$route.params.id}`).then(d => {
          this.race = d.data
        }).catch(e => {
          console.log(e)
        })
      }
      fccapi.competitionGet(`races`).then(d => {
        this.races = d.data;
        this.races.push({name: ''});
      }).catch(e => {
        console.log(e)
      })
    },
    methods: {
      save: function(){
        if(this.$route.params.id == 'new'){
          this.race.competitionId = this.$store.getters['competitionId']
          fccapi.post(`races`, this.race).then(d => {
            this.race = d.data;
            this.$router.replace('/app/races/' + d.data.id)
            this.snackbar = true;
          })
        }
        else {
          fccapi.post(`races/${this.$route.params.id}`, {
              name: this.race.name, 
              applicationType: this.race.applicationType,
              startNumberOffset: this.race.startNumberOffset,
              previousRaceId: this.race.previousRaceId,
              maximalRuns: this.race.maximalRuns,
              publicDisplay: this.race.publicDisplay,
              announcement: this.race.announcement
            }
          ).then(d => {
            this.snackbar = true;
          })
        }
      }
    }
  }
</script>